varying vec2 vUv;
varying vec3 vWorldPosition;

attribute vec3 aPositions;
attribute float aRandoms;

uniform float uTime;
uniform sampler2D uPerlin;
uniform sampler2D uHeightMap;
uniform vec3 uCameraPosition;
uniform float uSideLength;
uniform float uHeightScale;

// Funtion to look at the camera to implement the rotation
mat3 lookAt_rot(vec3 objectPos, vec3 cameraPos) {
  vec3 forward = normalize(cameraPos - objectPos);
  vec3 right = normalize(cross(vec3(0.0, 1.0, 0.0), forward));
  vec3 up = cross(forward, right);
  return mat3(right, up, forward);
}


void main () {

  vec3 localPosition = position;
  vec3 grassPosition = aPositions;

  // rotating the grass to face the camera ( not working when camera is at the top 🙁)
  vec3 axis = vec3(0.0, 1.0, 0.0);
  
  vec3 cameraDirection = normalize(uCameraPosition - localPosition);

  mat3 billboardMatrix = lookAt_rot(grassPosition, uCameraPosition);
  localPosition = billboardMatrix * localPosition;

  // Placing grass perfectly on the terrain
  vec2 heightUv = (grassPosition.xz + (uSideLength/2.0)) / uSideLength;
  heightUv.y = 1.0 - heightUv.y;
  float heightVariation = texture2D(uHeightMap, heightUv).r;
  vec3 newPosition = localPosition + grassPosition;
  newPosition.y += heightVariation * uHeightScale; 

  vec3 worldPosition = vec3(modelMatrix * vec4(position + grassPosition, 1.0));


  /* creating random position in x and z, also radom height in y axis */
  newPosition.y *= (aRandoms + 0.5);
  newPosition.x += (aRandoms - 0.5);
  newPosition.z += (aRandoms - 0.5);

  // Creating Wind Effect
  vec2 globalUv = worldPosition.xz * 0.1; 
  globalUv.x += uTime * 0.5;
  globalUv.y += uTime * 0.5;
  float noice = texture2D(uPerlin, globalUv * 0.1).r;
  newPosition.x += (((noice - 0.5) * 2.0) * uv.y);
  newPosition.z += (((noice - 0.5) * 2.0) * uv.y);


  gl_Position = projectionMatrix * modelViewMatrix * vec4(newPosition, 1.0);

  vUv = uv;
  vWorldPosition = worldPosition.xyz;
}